import React from "react";
import LoginComponent from "./components/LoginComponent";

export function Login() {
    return (
        <LoginComponent />
    )
}

export default Login;